import { type InputProps, Input as StandardInput } from '@/components/inputs/Input'
import { type InputRef } from 'antd'
import { forwardRef } from 'react'

import styles from './styles.module.scss'

export const Input = forwardRef<InputRef, InputProps>((props, ref) => {
  return <StandardInput ref={ref} {...props} className={styles.input} />
})

Input.displayName = 'Input'
